import React from "react";
import styled, { useTheme } from "styled-components";
import SignupInfoWeb from "./SingupInfoWeb";
import SignupInfoMobile from "./SignupInfoMobile";
import { useWindowSize } from "../../../../context/WindowSizeContext";

const Root = styled.div``;

const SignupInfo = () => {
  const size = useWindowSize();
  const theme = useTheme();
  const isMobile = size.width! <= parseInt(theme.breakpoints.mobileL);

  return <Root> {isMobile ? <SignupInfoMobile /> : <SignupInfoWeb />} </Root>;
};

export default SignupInfo;
